import GoogleGeoCoding from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/GoogleGeoCoding'
import PointGroupCatalog from '@/api/PointGroup/PointGroupCatalog'
import { PointGroupType } from '@/models/Simulation/Constants'
import AdvertiserApi from '@/api/AdvertiserApi'
import IOApi from '@/api/IOApi'
import LocationGroupOperation from '@/api/PointGroup/LocationGroupOperation/LocationGroupOperation'
import { SimulationLocation } from '@/models/Simulation/SimulationFormDelivery'
import { locationGroupType } from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants'

const actions = {
  PREV_STEP({ commit, getters }) {
    commit('SET_CURRENT_STEP', getters.currentStep - 1)
  },
  NEXT_STEP({ commit, getters }) {
    commit('SET_CURRENT_STEP', getters.currentStep + 1)
  },
  SET_STEP({ commit }, step) {
    commit('SET_CURRENT_STEP', step)
  },
  MODE({ commit }, mode) {
    commit('SET_MODE', mode)
  },
  async RESET({ commit }) {
    commit('RESET')
  },
  SET_MAP_CENTER({ commit }, latLng) {
    commit('SET_MAP_CENTER', latLng)
  },
  SET_MAP_ZOOM({ commit }, zoom) {
    commit('SET_MAP_ZOOM', zoom)
  },
  SELECT_GROUP({ commit, dispatch }, locationGroup) {
    dispatch('TRIGGER_FIT_BOUNDS')
    commit('SELECT_GROUP', locationGroup)
  },
  DESELECT_GROUP({ commit }) {
    commit('DESELECT_GROUP')
  },
  SET_LAST_DRAG_END_TIME({ commit }) {
    commit('SET_LAST_DRAG_END_TIME')
  },
  TRIGGER_FIT_BOUNDS({ commit }) {
    commit('SET_FIT_BOUNDS', true)
    setTimeout(() => {
      commit('SET_FIT_BOUNDS', false)
    }, 1000)
  },
  SELECT_LOCATION({ commit }, location) {
    commit('SELECT_LOCATION', location)
  },
  DESELECT_LOCATION({ commit }) {
    commit('DESELECT_LOCATION')
  },
  UPDATE_SELECTED_LOCATION({ commit }, location) {
    commit('UPDATE_SELECTED_LOCATION', location)
  },
  SET_LAST_SETTING_AREA_HEIGHT({ commit }, height) {
    commit('SET_LAST_SETTING_AREA_HEIGHT', height)
  },
  async SEARCH_LOCATION({ commit }, { query }) {
    commit('SEARCH_LOCATION')

    const options = { components: 'country:jp' }
    const res = await GoogleGeoCoding.placeAutoComplete(query, 'ja', options)
    if (res.status === 'INVALID_REQUEST') {
      commit('SEARCH_LOCATION_FAILURE')
    } else {
      commit('SEARCH_LOCATION_SUCCESS', res.predictions)
    }
  },
  async SET_FOCUS_INDEX({ commit }, index) {
    commit('SET_FOCUS_INDEX', index)
  },
  FOCUS_NEXT_SEARCH_RESULT({ state, commit }) {
    const currentIndex = state.search.forcedResultIndex
    const nextIndex = currentIndex === null ? 0 : currentIndex + 1
    commit('FOCUS_MOVE_SEARCH_RESULT', nextIndex)
  },
  FOCUS_PREV_SEARCH_RESULT({ state, commit }) {
    const currentIndex = state.search.forcedResultIndex
    const nextIndex = currentIndex - 1
    commit('FOCUS_MOVE_SEARCH_RESULT', nextIndex)
  },
  FOCUS_OUT_SEARCH_RESULT({ commit }) {
    commit('FOCUS_OUT_SEARCH_RESULT')
  },
  CLEAR_SEARCH_RESULT({ commit }) {
    commit('CLEAR_SEARCH_RESULT')
  },

  /** 地点グループ読み込みモーダル*/
  SELECT_POINT_GROUP_TYPE({ commit, dispatch }, type) {
    if (type === PointGroupType.OEM) {
      dispatch('FETCH_OEM_GROUP_LIST')
    }
    commit('SELECT_POINT_GROUP_TYPE', type)
  },
  SELECT_ADVERTISER({ state, commit, dispatch }, advertiserId) {
    const { selectedPointGroupType } = state.pointGroupImport
    if (selectedPointGroupType === PointGroupType.ADVERTISER) {
      dispatch('FETCH_ADVERTISER_GROUP_LIST', advertiserId)
    }
    if (selectedPointGroupType === PointGroupType.IO) {
      dispatch('FETCH_IO_LIST', advertiserId)
    }
    commit('SELECT_ADVERTISER', advertiserId)
  },
  SELECT_IO({ commit, dispatch }, ownerProfileId) {
    commit('SELECT_IO', ownerProfileId)
    dispatch('FETCH_IO_GROUP_LIST', ownerProfileId)
  },
  async FETCH_OEM_GROUP_LIST({ commit }) {
    const { ownerProfileId } = await PointGroupCatalog.getSystemOwner()
    const pointGroupList = await PointGroupCatalog.getGroupList(
      ownerProfileId,
      locationGroupType.CUSTOM_LOCATION,
    )
    commit('FETCH_POINT_GROUP_LIST_SUCCESS', pointGroupList)
  },
  async FETCH_ADVERTISER_LIST({ commit }, keyword) {
    const { items } = await AdvertiserApi.searchAdvertiser({
      keyword: keyword,
      minPermissionLevel: 'view',
    })
    commit('FETCH_ADVERTISER_LIST', items)
  },
  async FETCH_ADVERTISER_GROUP_LIST({ state, commit }, advertiserId) {
    const { ownerProfileId } = state.pointGroupImport.advertiserList.find(
      advertiser => advertiserId === advertiser.id,
    )
    const pointGroupList = await PointGroupCatalog.getGroupList(
      ownerProfileId,
      locationGroupType.CUSTOM_LOCATION,
    )
    commit('FETCH_POINT_GROUP_LIST_SUCCESS', pointGroupList)
  },
  async FETCH_IO_LIST({ commit }, advertiserId) {
    const { items } = await IOApi.fetchIOList({
      advertiserId: advertiserId,
    }).catch(e => {
      console.log(e)
      return []
    })
    commit('FETCH_IO_LIST_SUCCESS', items)
  },
  async FETCH_IO_GROUP_LIST({ commit }, ownerProfileId) {
    const pointGroupList = await PointGroupCatalog.getGroupList(
      ownerProfileId,
      locationGroupType.CUSTOM_LOCATION,
    )
    commit('FETCH_POINT_GROUP_LIST_SUCCESS', pointGroupList)
  },
  ADD_POINT_GROUP({ commit, dispatch }, pointGroup) {
    commit('ADD_GROUP', pointGroup)
    dispatch('FETCH_LOCATION_LIST', {
      groupId: pointGroup.id,
      locationGroupType: pointGroup.locationType,
    })
  },
  REMOVE_POINT_GROUP({ commit }, pointGroupId) {
    commit('REMOVE_POINT_GROUP', pointGroupId)
  },
  SELECT_POINT_GROUP({ commit, dispatch }, pointGroup) {
    commit('SELECT_POINT_GROUP', pointGroup)
    dispatch('FETCH_LOCATION_LIST', {
      groupId: pointGroup.id,
      locationGroupType: pointGroup.locationType,
    })
  },
  async FETCH_LOCATION_LIST({ commit }, { groupId, locationGroupType }) {
    const locationList = await LocationGroupOperation.getLocationList(
      groupId,
      locationGroupType,
    )
    const locations = await Promise.all(
      locationList.map(async location => {
        const { shape } = location
        location.id = undefined
        location.shape.type = 'Point'
        location.shape.coordinates = [shape.longitude, shape.latitude]
        return SimulationLocation.assign(location)
      }),
    )
    commit('FETCH_LOCATION_LIST_SUCCESS', {
      locations,
      groupId,
    })
  },
  SET_POINT_GROUP_IMPORT_MAP_CENTER({ commit }, center) {
    commit('SET_POINT_GROUP_IMPORT_MAP_CENTER', center)
  },
  POINT_GROUP_IMPORT_DESTROY_MODAL_VALUES({ commit }) {
    commit('POINT_GROUP_IMPORT_DESTROY_MODAL_VALUES')
  },
}

export default actions
